import styled from '@emotion/styled/macro';
import { PopoverItem, Variables } from '@enter/core';
import Icon from '@mdi/react';

export const LinkIcon = styled(Icon)`
    fill: ${Variables.Colors.n70};
    margin-left: 5px;
`;

export const StyledPopoverItem = styled(PopoverItem)`
    display: flex;
    align-items: center;
`;

export const ActionCellWrapper = styled.div`
    min-height: 40px;
    display: flex;
    align-items: center;
`;
